function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_624_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_640_",
  d: "m167.98 393.987h25.5c30.712 0 55.697-24.986 55.697-55.697v-32.976h-50.5c-18.902 0-35.623 9.472-45.697 23.911-10.074-14.438-26.795-23.911-45.696-23.911h-50.5v32.976c0 30.711 24.985 55.697 55.696 55.697h25.5v34.327h30z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_641_",
  d: "m447.33 398.987h14.266v-30h-14.266c-12.473 0-24.108 3.642-33.903 9.921-4.397-22.535-24.291-39.594-48.094-39.594h-22.333v30h22.333c10.477 0 19 8.523 19 19v40h30.209c1.832-16.473 15.835-29.327 32.788-29.327z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_642_",
  d: "m0 458.314h512v30h-512z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_646_",
  d: "m381.083 265.235 110.726-110.726-36.122-36.122 2.494-2.494c21.06-21.06 21.06-55.327 0-76.387-10.202-10.202-23.767-15.82-38.193-15.82-14.428 0-27.992 5.618-38.193 15.82l-2.495 2.494-18.084-18.084-110.726 110.726 35.984 35.984h-64.142v30h94.141zm21.924-204.516c4.536-4.536 10.565-7.033 16.98-7.033 6.414 0 12.444 2.498 16.98 7.033 9.362 9.363 9.362 24.598 0 33.961l-2.494 2.494-33.961-33.96z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_647_",
  d: "m167.98 274.667c0-19.31 15.71-35.019 35.02-35.019v-30c-35.852 0-65.02 29.167-65.02 65.019v13.314h30z"
}));

function Svg1011(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1011);
export default __webpack_public_path__ + "static/media/10_11.ad704456.svg";
export { ForwardRef as ReactComponent };